import axios from "../../vendors/axios/axios.js";
const performRequest = async (request) => {
  var _a;
  try {
    const response = await request;
    return [response == null ? void 0 : response.data, null];
  } catch (err) {
    return [null, ((_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data) ?? { data: { message: "System Error" } }];
  }
};
const requestAdapter = (instance = axios.create()) => ({
  ...instance,
  get: async (...params) => performRequest(instance.get(...params)),
  post: async (...params) => performRequest(instance.post(...params)),
  put: async (...params) => performRequest(instance.put(...params)),
  patch: async (...params) => performRequest(instance.patch(...params)),
  delete: async (...params) => performRequest(instance.delete(...params))
});
export {
  requestAdapter
};
//# sourceMappingURL=index.js.map
